/* import __COLOCATED_TEMPLATE__ from './pagination.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();